import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {SessionService} from "../service/session.service";
import {SvgIconService} from "../service/svg-icon.service";
import {SideMenu} from "../../shared/interface/sideMenu";
import {MENU_LIST} from "../../shared/constants";

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css']
})
export class SideMenuComponent implements OnInit {
  isCustomerAdmin: boolean;
  isNabelAdmin: boolean;
  menuList: SideMenu[];

  @Output() clickMenuItem = new EventEmitter<any>();

  constructor(public sessionService: SessionService,
              private svgIconService: SvgIconService) {
    const ps = this.sessionService.session.personalSetting;
    this.isCustomerAdmin = !!ps?.customerAdmin?.length;
    this.isNabelAdmin = ps?.nabelAdmin ?? false;
    this.menuList = MENU_LIST(this.isCustomerAdmin, this.isNabelAdmin);
  }

  ngOnInit(): void {
    this.svgIconService.registerIcons();
  }

}
